module.exports = __webpack_public_path__ + "img/carga-ready.a3b37795.svg";